import codedLogo from "../components/pictures/logos/coded-wordmark-navy.webp";
import ITS from "../components/pictures/logos/ITS.png";
import AUM from "../components/pictures/logos/AUM-Logo.png";
import YonseiUniversity from "../components/pictures/logos/Yonsei University.svg.webp";
import microFocus from "../components/pictures/logos/microFocus.png";
import fireship from "../components/pictures/logos/fireship.png";
import IbmLogo from "../components/pictures/logos/IBM.png";
import McKinseyLogo from "../components/pictures/logos/mckensey.png";

import introductionToTCPIP from "../components/pictures/certificates/Introduction to TCP_IP by Yonsei University.pdf";
import IbmDataAnalyst from "../components/pictures/certificates/IBM_Data_Analyst.pdf";
import forwardPdf from "../components/pictures/certificates/Forward.pdf";

import excelEssentials from "../components/pictures/bagdes/excel-essentials-for-data-analytics.png";
import dataVisualizationDashboardEssentials from "../components/pictures/bagdes/data-visualization-dashboard-essentials.png";
import pythonForDataScienceAndAi from "../components/pictures/bagdes/python-for-data-science-and-ai.png";
import pythonProjectForDataScience from "../components/pictures/bagdes/python-project-for-data-science.png";
import databasesAndSqlForDataScience from "../components/pictures/bagdes/databases-and-sql-for-data-science.png";
import dataAnalysisWithPython from "../components/pictures/bagdes/data-analysis-with-python.png";
import dataVisualizationWithPython from "../components/pictures/bagdes/data-visualization-with-python.png";
import generativeAiEssentialsForDataAnalytics from "../components/pictures/bagdes/generative-ai-essentials-for-data-analytics.png";
import dataAnalystCareerGuide from "../components/pictures/bagdes/data-analyst-career-guide-and-interview-preparation.png";
import dataAnalystCapstoneProject from "../components/pictures/bagdes/data-analyst-capstone-project.png";
import mckinseyForward from "../components/pictures/bagdes/mckinsey-org-forward-program.png";
import arcSightESMAdvancedAnalyst from "../components/pictures/bagdes/ArcSight ESM Advanced Analyst.png";
export const certificatesData = [
  // Add data for other educations here
  {
    date: "2026",
    icon: (
      <img
        src={McKinseyLogo}
        alt="McKinsey Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "McKinsey Forward",
    subTitle: "certificates.mckinsey_forward.subTitle",
    companyName: "McKinsey",
    link: "https://www.mckinsey.org/our-programs/forward/overview",
    showCertificate: true,
    certificatePath: forwardPdf,
    showBadges: true,
    badges: [{ src: mckinseyForward, alt: "McKinsey Forward" }],
  },
  {
    date: "2026",
    icon: (
      <img
        src={IbmLogo}
        alt="IBM Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.ibm_data_analyst.title",
    subTitle: "certificates.ibm_data_analyst.subTitle",
    companyName: "IBM",
    link: "https://www.coursera.org/professional-certificates/ibm-data-analyst",
    showCertificate: true,
    certificatePath: IbmDataAnalyst,
    showBadges: true,
    badges: [
      { src: excelEssentials, alt: "Excel essentials for data analytics" },
      {
        src: dataVisualizationDashboardEssentials,
        alt: "Data visualization dashboard essentials",
      },
      {
        src: pythonForDataScienceAndAi,
        alt: "Python for data science and AI",
      },
      {
        src: pythonProjectForDataScience,
        alt: "Python project for data science",
      },
      {
        src: databasesAndSqlForDataScience,
        alt: "Databases and sql for data science",
      },
      {
        src: dataAnalysisWithPython,
        alt: "Data analysis with python",
      },
      {
        src: dataVisualizationWithPython,
        alt: "Data visualization with python",
      },
      {
        src: generativeAiEssentialsForDataAnalytics,
        alt: "Generative AI essentials for data analytics",
      },
      {
        src: dataAnalystCareerGuide,
        alt: "Data analyst career guide and interview preparation",
      },
      {
        src: dataAnalystCapstoneProject,
        alt: "Data analyst capstone project",
      },
    ],
  },
  {
    date: "2023",
    icon: (
      <img
        src={fireship}
        alt="fireship Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.next_js_13_full_course.title",
    subTitle: "certificates.next_js_13_full_course.subTitle",
    companyName: "Fireship",
    link: "https://fireship.io/",
    showCertificate: false,
    showBadges: false,
  },
  {
    date: "2020",
    icon: (
      <img
        src={microFocus}
        alt="micro focus Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.esm320_arcsight_esm_7_3_advanced_analyst.title",
    subTitle: "certificates.esm320_arcsight_esm_7_3_advanced_analyst.subTitle",
    companyName: "Micro Focus",
    link: "https://www.microfocus.com/",
    showCertificate: false,
    showBadges: true,
    badges: [
      { src: arcSightESMAdvancedAnalyst, alt: "ArcSight ESM Advanced Analyst" },
    ],
  },
  {
    date: "2020",
    icon: (
      <img
        src={microFocus}
        alt="micro focus Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title:
      "certificates.esm200_arcsight_esm_7_2_administrator_and_analyst.title",
    subTitle:
      "certificates.esm200_arcsight_esm_7_2_administrator_and_analyst.subTitle",
    companyName: "Micro Focus",
    link: "https://www.microfocus.com/",
    showCertificate: false,
    showBadges: false,
  },
  {
    date: "2020",
    icon: (
      <img
        src={YonseiUniversity}
        alt="Yonsei University Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.introduction_to_tcp_ip_course.title",
    subTitle: "certificates.introduction_to_tcp_ip_course.subTitle",
    companyName: "certificates.introduction_to_tcp_ip_course.companyName",
    link: "https://www.coursera.org/learn/tcpip",
    showCertificate: true,
    certificatePath: introductionToTCPIP,
    showBadges: false,
  },
  {
    date: "08.2019 - 11.2019",
    icon: (
      <img
        src={codedLogo}
        alt="Coded Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.fresh_grad_bootcamp.title",
    subTitle: "certificates.fresh_grad_bootcamp.subTitle",
    companyName: "CODED Academy",
    link: "https://coded.kw/",
    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "REST API",
      "Python",
      "Django",
      "JavaScript",
      "React",
      "Redux",
      "React Native",
    ],
    projects: [
      {
        title: "RobinFood",
        subTitle: "certificates.fresh_grad_bootcamp.projects.0.subTitle",
      },
      {
        title: "Major Quest",
        subTitle: "certificates.fresh_grad_bootcamp.projects.1.subTitle",
      },
    ],
    showCertificate: false,
    showBadges: false,
  },
  {
    date: "2017",
    icon: (
      <img
        src={ITS}
        alt="ITS Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.business_awareness_program.title",
    subTitle: "certificates.business_awareness_program.subTitle",
    companyName: "ITS",
    link: "https://www.its.ws/",
    showCertificate: false,
    showBadges: false,
  },
  {
    date: "2017",
    icon: (
      <img
        src={AUM}
        alt="AUM Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    title: "certificates.effective_teamwork_workshop.title",
    subTitle: "certificates.effective_teamwork_workshop.subTitle",
    companyName: "certificates.effective_teamwork_workshop.companyName",
    link: "https://aum.edu.kw/",
    showCertificate: false,
    showBadges: false,
  },
];
